import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import CofferMaker from '@elem/SVGIcon/PowerBackup/CoffeeMaker';
// import CAPA from 'elem/SVGIcon/OutdoorRecreation/CAPA';
import Fan from 'elem/SVGIcon/OutdoorRecreation/Fan';
import Display from 'elem/SVGIcon/PowerBackup/Display';
import Laptop from 'elem/SVGIcon/PowerBackup/Laptop';
import Light from 'elem/SVGIcon/PowerBackup/Light';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import WiFiRouter from 'elem/SVGIcon/PowerBackup/WiFiRouter';
import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

export default function D({ callBuy }: any) {
    const { useLang, useRouter, useState, useEffect, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('loadshedding');

    const [gap, setGap] = useState(24);
    const cards: any = [
        {
            power: t('secD_card1_power'),
            title: t('secD_card1_title'),
            productId: (() => {
                const localMap: any = {
                    za: '7654598541521',
                };
                return localMap[locale] || localMap.za;
            })(),
            variantId: (() => {
                const localMap: any = {
                    za: '42877882106065',
                };
                return localMap[locale] || localMap.za;
            })(),
            descArr: [t('secD_card1_desc1'), t('secD_card1_desc2'), t('secD_card1_desc3')],
            iconArr: [
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secD_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card1_icon1_desc'),
                },
                {
                    icon: <Display className="card-icon" />,
                    title: t.rich('secD_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card1_icon2_desc'),
                },
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secD_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card1_icon3_desc'),
                },
                {
                    icon: <Fan className="card-icon" />,
                    title: t.rich('secD_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card1_icon4_desc'),
                },
                {
                    icon: <WiFiRouter className="card-icon" />,
                    title: t.rich('secD_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card1_icon5_desc'),
                },
                {
                    icon: <Laptop className="card-icon" />,
                    title: t.rich('secD_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card1_icon6_desc'),
                },
            ],
        },
        {
            power: t('secD_card2_power'),
            title: t('secD_card2_title'),
            productId: (() => {
                const localMap: any = {
                    za: '7187058753745',
                };
                return localMap[locale] || localMap.za;
            })(),
            variantId: (() => {
                const localMap: any = {
                    za: '41462253813969',
                };
                return localMap[locale] || localMap.za;
            })(),
            descArr: [t('secD_card2_desc1'), t('secD_card2_desc2'), t('secD_card2_desc3')],
            iconArr: [
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secD_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card2_icon1_desc'),
                },
                {
                    icon: <Display className="card-icon" />,
                    title: t.rich('secD_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card2_icon2_desc'),
                },
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secD_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card2_icon3_desc'),
                },
                {
                    icon: <Fan className="card-icon" />,
                    title: t.rich('secD_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card2_icon4_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secD_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card2_icon5_desc'),
                },
                {
                    icon: <CofferMaker className="card-icon" />,
                    title: t.rich('secD_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secD_card2_icon6_desc'),
                },
            ],
        },
    ];

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: card.title,
                position: `Load Shedding Page_${card?.title}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            // window.open(card?.link_buy, '_blank');
            callBuy({
                discountPrice: card?.discountPrice,
                originalPrice: card?.originalPrice,
                inventory: card?.inventory,
                productId: card?.productId,
                variantId: card?.variantId,
                img: card?.img,
                title: card?.title,
                skuTitle: card?.skuTitle,
            });
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    useEffect(() => {
        const tempArr = [...cards];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryPolicy === 'continue' ? 99 : res?.data?.inventoryQuantity ?? 0;
                        tempArr[k].skuTitle = res?.data?.skuTitle;
                        tempArr[k].productTitle = res?.data?.productTitle;
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}`;
                        tempArr[k].img = res?.data?.variantImg || res?.data?.img;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="load-shedding-D" className={`load-shedding-D ${css['load-shedding-D']}`}>
            <div className="text-box">
                <h2 className="title">{t('secD_title')}</h2>
                <p className="desc">{t('secD_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/load-shedding/4.jpg`}
                    srcPad={`/responsive/picture/load-shedding/4_768.jpg`}
                    srcMobile={`/responsive/picture/load-shedding/4_768.jpg`}
                    alt={t('secD_title')}
                />
            </div>
            <Swiper
                className="cards swiper-box"
                effect="fade"
                // modules={[Scrollbar]}
                spaceBetween={gap}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                // scrollbar={{
                //     hide: false,
                //     draggable: true,
                //     dragSize: 32,
                //     snapOnRelease: true,
                // }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EFPicture src={card?.img} alt={card?.title} />
                        <p className="card-power">{card?.power}</p>
                        <h3 className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</h3>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <ul className="card-icons">
                            {card?.iconArr?.map((icon: any, n: number) => (
                                <li className="card-icon-item" key={`${k}_${n}`}>
                                    {icon?.icon}
                                    <p className="icon-title">{icon?.title}</p>
                                    <p className="icon-desc">{icon?.desc}</p>
                                </li>
                            ))}
                        </ul>
                        <div className="card-btns">
                            {card?.link_buy && (
                                <>
                                    {Number(card?.inventory) <= 0 ? (
                                        <button disabled className={`btn-buy card-btn disable`}>
                                            {t('common_card_out')}
                                        </button>
                                    ) : (
                                        <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                            {t('common_card_buy')}
                                        </p>
                                    )}
                                </>
                            )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${
                                        String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                    }utm_source=scenario+page&utm_medium=Pillar`}
                                    target="_blank"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        list_name: t('secD_title'),
                                        product_name: card.title,
                                        button_name: t('common_card_more'),
                                    }}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
